import { ConfigurationEnumsService_enumsServiceGetGetEnum } from '@festina/unitlink-general-types/unitlink/hooks/ConfigurationEnumsService_enumsServiceGetGetEnum'

export const useFetchEnumValues =
  ConfigurationEnumsService_enumsServiceGetGetEnum.useSuspenseQuery
